import React from 'react';

function News() {
  return (
    <div>
      <h1>News</h1>
      <p>Latest updates will appear here.</p>
    </div>);

}

export default News;